import * as Sentry from "@sentry/react";

export function initErrorMonitoring(sentryDsn, { tracesSampleRate = 0.1 } = {}) {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [
            Sentry.replayIntegration()
        ],
        // Session Replay
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.1, // 10% of errors will be recorded
        // Tracing
        tracesSampleRate: tracesSampleRate, // 10% of traces will be sent
        ignoreErrors: [
            'No slot size for availableWidth=0',
            /adsbygoogle.*push/i,
            /AbortError/i,
            'Non-Error promise rejection captured',
            "Failed to execute 'animate' on 'Element': Partial keyframes are not supported."
        ],
        denyUrls: [
            /r1\/jsobfuscated\/h5-i\.js$/ // ignore errors from h5-i.js (video ads)
        ]
    });
}

export function trackError(error) {
    Sentry.captureException(error);
}